<script setup>
import MembershipWeb from '@/components/membership/membership.vue'
import MembershipMobile from '@/components/membership/membership-mobile.vue'
const IS_Mobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|HarmonyOS|OpenHarmony/i.test(navigator.userAgent);
const IS_H5 = IS_Mobile || window.innerWidth <= 768;
</script>
<template>
  <!-- /* 判读是从哪个入口进入 */ -->
  <MembershipMobile v-if="IS_H5" />
  <MembershipWeb v-else />
</template>
<style lang="scss" scoped></style>
